import { render, staticRenderFns } from "./Quotationprint.vue?vue&type=template&id=3b2346e6&"
import script from "./Quotationprint.vue?vue&type=script&lang=js&"
export * from "./Quotationprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports